module.exports = __webpack_public_path__ + "img/tw.26cc9d59.svg";